import type { FileTree } from "api";
import type { FC } from "react";

import File from "./File";

interface DirectoryProps extends FileTree {
  executionId: string;
  path?: string;
}

const Directory: FC<DirectoryProps> = props => {
  const { executionId, dir, content, path = "" } = props;
  const subPath = [path.replace(/^\//, ""), dir]
    .filter(Boolean)
    .join("/")
    .replace(/^\//, "");
  return (
    <div className="flex flex-col items-start gap-2">
      <div>{`📁 ${dir}`}</div>
      <div className="flex flex-col items-start gap-2 pl-2 ml-2 border-l-2 border-dashed border-gray-600">
        {content.map(i => {
          if (typeof i === "string") {
            return (
              <File key={i} file={i} executionId={executionId} path={subPath} />
            );
          }
          return (
            <Directory
              key={i.dir}
              {...i}
              executionId={executionId}
              path={subPath}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Directory;
